module.exports = __webpack_public_path__ + "img/biaoqian_shangchang.55523778.png";